/**
 * Generated by orval v8.12.2 🍺
 * Do not edit manually.
 * PEXIFY API
 * PEXIFY API contract (FE ↔ BE).
 *
 * **Status:** M0 initial draft (2026-05-21). This contract is FE-shaped during M0/M1/M2 operational
 * simulation phase per `pol-build-sequence`. Backend implementation begins at M3.
 *
 * **Scope (M0):** IQ-1 Pending Updates Queue endpoints + auth placeholder. Other endpoints added
 * as M0/M1/M2 prototype reveals needs.
 *
 * **Permanent architectural invariant:** JSON only (no GraphQL, no SOAP, no XML). See
 * `planning/nodes/policies/decoupled-api.md` for the full invariant + 5 strategic reasons.
 *
 * OpenAPI spec version: 0.1.0-m0-draft
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Problem,
  RemoteAccessErrorResponse,
  RemoteAssignmentPolicyRead,
  RemoteAssignmentPolicyWrite,
  RemoteBoardStoreLabelsRead,
  RemoteBoardStoresRead,
  RemoteGatewayResultAck,
  RemoteGatewayResultReport,
  RemoteHostListResponse,
  RemoteHostOwnerWrite,
  RemoteHostRead,
  RemoteLaunchIntent,
  RemoteLaunchReplayResponse,
  RemoteLaunchTicketConsumeRequest,
  RemoteLaunchTicketConsumeResponse,
  RemoteLinkableStoresRead,
  RemoteReconcileRequest,
  RemoteReconcileResponse,
  RemoteSelectedAssignmentsRead,
  RemoteSelectedAssignmentsWrite,
  RemoteSellerOrgsRead,
  RemoteSessionCloseRequest,
  RemoteSessionRead,
  RemoteStoreLabelRead,
  RemoteStoreLabelWrite,
  RemoteStoreLabelsRead,
  RemoteStoreLinkRead,
  RemoteStoreLinkWrite,
  RemoteStoreLinksRead,
  RemoteTakeoverDecisionAck,
  RemoteTakeoverOperatorDecision,
  RemoteTakeoverOperatorReject,
  RemoteTakeoverWarning,
  StoreProductGroupRead,
  StoreProductGroupWrite,
  StoreProductGroupsRead
} from '../model';

import { orvalClient } from '../../orval-client';




export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;


export type getRemoteSessionTakeoverResponse200 = {
  data: RemoteTakeoverWarning | null
  status: 200
}

export type getRemoteSessionTakeoverResponse401 = {
  data: RemoteAccessErrorResponse
  status: 401
}

export type getRemoteSessionTakeoverResponse404 = {
  data: RemoteAccessErrorResponse
  status: 404
}

export type getRemoteSessionTakeoverResponse409 = {
  data: RemoteAccessErrorResponse
  status: 409
}

export type getRemoteSessionTakeoverResponse422 = {
  data: RemoteAccessErrorResponse
  status: 422
}

export type getRemoteSessionTakeoverResponseSuccess = (getRemoteSessionTakeoverResponse200) & {
  headers: Headers;
};
export type getRemoteSessionTakeoverResponseError = (getRemoteSessionTakeoverResponse401 | getRemoteSessionTakeoverResponse404 | getRemoteSessionTakeoverResponse409 | getRemoteSessionTakeoverResponse422) & {
  headers: Headers;
};

export type getRemoteSessionTakeoverResponse = (getRemoteSessionTakeoverResponseSuccess | getRemoteSessionTakeoverResponseError)

export const getGetRemoteSessionTakeoverUrl = (sessionId: string,) => {




  return `/api/v1/internal/remote-access/sessions/${sessionId}/takeover`
}

/**
 * @summary Get Session Takeover
 */
export const getRemoteSessionTakeover = async (sessionId: string, options?: RequestInit): Promise<getRemoteSessionTakeoverResponse> => {

  return orvalClient<getRemoteSessionTakeoverResponse>(getGetRemoteSessionTakeoverUrl(sessionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRemoteSessionTakeoverQueryKey = (sessionId: string,) => {
    return [
    `/api/v1/internal/remote-access/sessions/${sessionId}/takeover`
    ] as const;
    }


export const getGetRemoteSessionTakeoverQueryOptions = <TData = Awaited<ReturnType<typeof getRemoteSessionTakeover>>, TError = RemoteAccessErrorResponse>(sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRemoteSessionTakeover>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRemoteSessionTakeoverQueryKey(sessionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRemoteSessionTakeover>>> = ({ signal }) => getRemoteSessionTakeover(sessionId, { signal });





   return  { queryKey, queryFn, enabled: sessionId !== null && sessionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRemoteSessionTakeover>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRemoteSessionTakeoverQueryResult = NonNullable<Awaited<ReturnType<typeof getRemoteSessionTakeover>>>
export type GetRemoteSessionTakeoverQueryError = RemoteAccessErrorResponse


export function useGetRemoteSessionTakeover<TData = Awaited<ReturnType<typeof getRemoteSessionTakeover>>, TError = RemoteAccessErrorResponse>(
 sessionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRemoteSessionTakeover>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRemoteSessionTakeover>>,
          TError,
          Awaited<ReturnType<typeof getRemoteSessionTakeover>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRemoteSessionTakeover<TData = Awaited<ReturnType<typeof getRemoteSessionTakeover>>, TError = RemoteAccessErrorResponse>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRemoteSessionTakeover>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRemoteSessionTakeover>>,
          TError,
          Awaited<ReturnType<typeof getRemoteSessionTakeover>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRemoteSessionTakeover<TData = Awaited<ReturnType<typeof getRemoteSessionTakeover>>, TError = RemoteAccessErrorResponse>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRemoteSessionTakeover>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Session Takeover
 */

export function useGetRemoteSessionTakeover<TData = Awaited<ReturnType<typeof getRemoteSessionTakeover>>, TError = RemoteAccessErrorResponse>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRemoteSessionTakeover>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRemoteSessionTakeoverQueryOptions(sessionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type handOverRemoteSessionTakeoverResponse200 = {
  data: RemoteTakeoverDecisionAck
  status: 200
}

export type handOverRemoteSessionTakeoverResponse401 = {
  data: RemoteAccessErrorResponse
  status: 401
}

export type handOverRemoteSessionTakeoverResponse404 = {
  data: RemoteAccessErrorResponse
  status: 404
}

export type handOverRemoteSessionTakeoverResponse409 = {
  data: RemoteAccessErrorResponse
  status: 409
}

export type handOverRemoteSessionTakeoverResponse422 = {
  data: RemoteAccessErrorResponse
  status: 422
}

export type handOverRemoteSessionTakeoverResponseSuccess = (handOverRemoteSessionTakeoverResponse200) & {
  headers: Headers;
};
export type handOverRemoteSessionTakeoverResponseError = (handOverRemoteSessionTakeoverResponse401 | handOverRemoteSessionTakeoverResponse404 | handOverRemoteSessionTakeoverResponse409 | handOverRemoteSessionTakeoverResponse422) & {
  headers: Headers;
};

export type handOverRemoteSessionTakeoverResponse = (handOverRemoteSessionTakeoverResponseSuccess | handOverRemoteSessionTakeoverResponseError)

export const getHandOverRemoteSessionTakeoverUrl = (sessionId: string,) => {




  return `/api/v1/internal/remote-access/sessions/${sessionId}/takeover/hand-over-now`
}

/**
 * @summary Hand Over Session Takeover
 */
export const handOverRemoteSessionTakeover = async (sessionId: string,
    remoteTakeoverOperatorDecision: RemoteTakeoverOperatorDecision, options?: RequestInit): Promise<handOverRemoteSessionTakeoverResponse> => {

  return orvalClient<handOverRemoteSessionTakeoverResponse>(getHandOverRemoteSessionTakeoverUrl(sessionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remoteTakeoverOperatorDecision)
  }
);}




export const getHandOverRemoteSessionTakeoverMutationOptions = <TError = RemoteAccessErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handOverRemoteSessionTakeover>>, TError,{sessionId: string;data: RemoteTakeoverOperatorDecision}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof handOverRemoteSessionTakeover>>, TError,{sessionId: string;data: RemoteTakeoverOperatorDecision}, TContext> => {

const mutationKey = ['handOverRemoteSessionTakeover'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof handOverRemoteSessionTakeover>>, {sessionId: string;data: RemoteTakeoverOperatorDecision}> = (props) => {
          const {sessionId,data} = props ?? {};

          return  handOverRemoteSessionTakeover(sessionId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HandOverRemoteSessionTakeoverMutationResult = NonNullable<Awaited<ReturnType<typeof handOverRemoteSessionTakeover>>>
    export type HandOverRemoteSessionTakeoverMutationBody = RemoteTakeoverOperatorDecision
    export type HandOverRemoteSessionTakeoverMutationError = RemoteAccessErrorResponse

    /**
 * @summary Hand Over Session Takeover
 */
export const useHandOverRemoteSessionTakeover = <TError = RemoteAccessErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handOverRemoteSessionTakeover>>, TError,{sessionId: string;data: RemoteTakeoverOperatorDecision}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof handOverRemoteSessionTakeover>>,
        TError,
        {sessionId: string;data: RemoteTakeoverOperatorDecision},
        TContext
      > => {
      return useMutation(getHandOverRemoteSessionTakeoverMutationOptions(options), queryClient);
    }
    export type rejectRemoteSessionTakeoverResponse200 = {
  data: RemoteTakeoverDecisionAck
  status: 200
}

export type rejectRemoteSessionTakeoverResponse401 = {
  data: RemoteAccessErrorResponse
  status: 401
}

export type rejectRemoteSessionTakeoverResponse404 = {
  data: RemoteAccessErrorResponse
  status: 404
}

export type rejectRemoteSessionTakeoverResponse409 = {
  data: RemoteAccessErrorResponse
  status: 409
}

export type rejectRemoteSessionTakeoverResponse422 = {
  data: RemoteAccessErrorResponse
  status: 422
}

export type rejectRemoteSessionTakeoverResponseSuccess = (rejectRemoteSessionTakeoverResponse200) & {
  headers: Headers;
};
export type rejectRemoteSessionTakeoverResponseError = (rejectRemoteSessionTakeoverResponse401 | rejectRemoteSessionTakeoverResponse404 | rejectRemoteSessionTakeoverResponse409 | rejectRemoteSessionTakeoverResponse422) & {
  headers: Headers;
};

export type rejectRemoteSessionTakeoverResponse = (rejectRemoteSessionTakeoverResponseSuccess | rejectRemoteSessionTakeoverResponseError)

export const getRejectRemoteSessionTakeoverUrl = (sessionId: string,) => {




  return `/api/v1/internal/remote-access/sessions/${sessionId}/takeover/reject`
}

/**
 * @summary Reject Session Takeover
 */
export const rejectRemoteSessionTakeover = async (sessionId: string,
    remoteTakeoverOperatorReject: RemoteTakeoverOperatorReject, options?: RequestInit): Promise<rejectRemoteSessionTakeoverResponse> => {

  return orvalClient<rejectRemoteSessionTakeoverResponse>(getRejectRemoteSessionTakeoverUrl(sessionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remoteTakeoverOperatorReject)
  }
);}




export const getRejectRemoteSessionTakeoverMutationOptions = <TError = RemoteAccessErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectRemoteSessionTakeover>>, TError,{sessionId: string;data: RemoteTakeoverOperatorReject}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof rejectRemoteSessionTakeover>>, TError,{sessionId: string;data: RemoteTakeoverOperatorReject}, TContext> => {

const mutationKey = ['rejectRemoteSessionTakeover'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectRemoteSessionTakeover>>, {sessionId: string;data: RemoteTakeoverOperatorReject}> = (props) => {
          const {sessionId,data} = props ?? {};

          return  rejectRemoteSessionTakeover(sessionId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectRemoteSessionTakeoverMutationResult = NonNullable<Awaited<ReturnType<typeof rejectRemoteSessionTakeover>>>
    export type RejectRemoteSessionTakeoverMutationBody = RemoteTakeoverOperatorReject
    export type RejectRemoteSessionTakeoverMutationError = RemoteAccessErrorResponse

    /**
 * @summary Reject Session Takeover
 */
export const useRejectRemoteSessionTakeover = <TError = RemoteAccessErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectRemoteSessionTakeover>>, TError,{sessionId: string;data: RemoteTakeoverOperatorReject}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rejectRemoteSessionTakeover>>,
        TError,
        {sessionId: string;data: RemoteTakeoverOperatorReject},
        TContext
      > => {
      return useMutation(getRejectRemoteSessionTakeoverMutationOptions(options), queryClient);
    }
    export type listAdminRemoteHostsResponse200 = {
  data: RemoteHostListResponse
  status: 200
}

export type listAdminRemoteHostsResponse403 = {
  data: Problem
  status: 403
}

export type listAdminRemoteHostsResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200 | 403>
}

export type listAdminRemoteHostsResponseSuccess = (listAdminRemoteHostsResponse200) & {
  headers: Headers;
};
export type listAdminRemoteHostsResponseError = (listAdminRemoteHostsResponse403 | listAdminRemoteHostsResponseDefault) & {
  headers: Headers;
};

export type listAdminRemoteHostsResponse = (listAdminRemoteHostsResponseSuccess | listAdminRemoteHostsResponseError)

export const getListAdminRemoteHostsUrl = () => {




  return `/api/v1/admin/remote-access/hosts`
}

/**
 * Returns the safe PEXIFY projection only; gateway topology, target accounts, and assignments for other memberships never leave the control plane.
 * @summary List the authenticated Admin membership's assigned remote hosts
 */
export const listAdminRemoteHosts = async ( options?: RequestInit): Promise<listAdminRemoteHostsResponse> => {

  return orvalClient<listAdminRemoteHostsResponse>(getListAdminRemoteHostsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminRemoteHostsQueryKey = () => {
    return [
    `/api/v1/admin/remote-access/hosts`
    ] as const;
    }


export const getListAdminRemoteHostsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminRemoteHosts>>, TError = Problem>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHosts>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminRemoteHostsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminRemoteHosts>>> = ({ signal }) => listAdminRemoteHosts({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHosts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminRemoteHostsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminRemoteHosts>>>
export type ListAdminRemoteHostsQueryError = Problem


export function useListAdminRemoteHosts<TData = Awaited<ReturnType<typeof listAdminRemoteHosts>>, TError = Problem>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHosts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminRemoteHosts>>,
          TError,
          Awaited<ReturnType<typeof listAdminRemoteHosts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminRemoteHosts<TData = Awaited<ReturnType<typeof listAdminRemoteHosts>>, TError = Problem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHosts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminRemoteHosts>>,
          TError,
          Awaited<ReturnType<typeof listAdminRemoteHosts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminRemoteHosts<TData = Awaited<ReturnType<typeof listAdminRemoteHosts>>, TError = Problem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHosts>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the authenticated Admin membership's assigned remote hosts
 */

export function useListAdminRemoteHosts<TData = Awaited<ReturnType<typeof listAdminRemoteHosts>>, TError = Problem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHosts>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminRemoteHostsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type approveAdminRemoteHostResponse200 = {
  data: RemoteHostRead
  status: 200
}

export type approveAdminRemoteHostResponse403 = {
  data: Problem
  status: 403
}

export type approveAdminRemoteHostResponse404 = {
  data: RemoteAccessErrorResponse
  status: 404
}

export type approveAdminRemoteHostResponse409 = {
  data: RemoteAccessErrorResponse
  status: 409
}

export type approveAdminRemoteHostResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200 | 403 | 404 | 409>
}

export type approveAdminRemoteHostResponseSuccess = (approveAdminRemoteHostResponse200) & {
  headers: Headers;
};
export type approveAdminRemoteHostResponseError = (approveAdminRemoteHostResponse403 | approveAdminRemoteHostResponse404 | approveAdminRemoteHostResponse409 | approveAdminRemoteHostResponseDefault) & {
  headers: Headers;
};

export type approveAdminRemoteHostResponse = (approveAdminRemoteHostResponseSuccess | approveAdminRemoteHostResponseError)

export const getApproveAdminRemoteHostUrl = (remoteHostId: string,) => {




  return `/api/v1/admin/remote-access/hosts/${remoteHostId}/approve`
}

/**
 * Moves a host out of `pending` into the ordinary lifecycle, where reconciliation decides whether it is reachable. Grants nobody access; who may use the server is a separate decision made by assigning it.
 * @summary Approve a server discovered on the gateway
 */
export const approveAdminRemoteHost = async (remoteHostId: string, options?: RequestInit): Promise<approveAdminRemoteHostResponse> => {

  return orvalClient<approveAdminRemoteHostResponse>(getApproveAdminRemoteHostUrl(remoteHostId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getApproveAdminRemoteHostMutationOptions = <TError = Problem | RemoteAccessErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveAdminRemoteHost>>, TError,{remoteHostId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof approveAdminRemoteHost>>, TError,{remoteHostId: string}, TContext> => {

const mutationKey = ['approveAdminRemoteHost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveAdminRemoteHost>>, {remoteHostId: string}> = (props) => {
          const {remoteHostId} = props ?? {};

          return  approveAdminRemoteHost(remoteHostId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveAdminRemoteHostMutationResult = NonNullable<Awaited<ReturnType<typeof approveAdminRemoteHost>>>

    export type ApproveAdminRemoteHostMutationError = Problem | RemoteAccessErrorResponse

    /**
 * @summary Approve a server discovered on the gateway
 */
export const useApproveAdminRemoteHost = <TError = Problem | RemoteAccessErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveAdminRemoteHost>>, TError,{remoteHostId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveAdminRemoteHost>>,
        TError,
        {remoteHostId: string},
        TContext
      > => {
      return useMutation(getApproveAdminRemoteHostMutationOptions(options), queryClient);
    }
    export type setAdminRemoteHostOwnerResponse200 = {
  data: RemoteHostRead
  status: 200
}

export type setAdminRemoteHostOwnerResponse403 = {
  data: Problem
  status: 403
}

export type setAdminRemoteHostOwnerResponse404 = {
  data: RemoteAccessErrorResponse
  status: 404
}

export type setAdminRemoteHostOwnerResponse422 = {
  data: Problem
  status: 422
}

export type setAdminRemoteHostOwnerResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200 | 403 | 404 | 422>
}

export type setAdminRemoteHostOwnerResponseSuccess = (setAdminRemoteHostOwnerResponse200) & {
  headers: Headers;
};
export type setAdminRemoteHostOwnerResponseError = (setAdminRemoteHostOwnerResponse403 | setAdminRemoteHostOwnerResponse404 | setAdminRemoteHostOwnerResponse422 | setAdminRemoteHostOwnerResponseDefault) & {
  headers: Headers;
};

export type setAdminRemoteHostOwnerResponse = (setAdminRemoteHostOwnerResponseSuccess | setAdminRemoteHostOwnerResponseError)

export const getSetAdminRemoteHostOwnerUrl = (remoteHostId: string,) => {




  return `/api/v1/admin/remote-access/hosts/${remoteHostId}/owner`
}

/**
 * Ours and a named customer are display grouping only. Choosing a seller gives that seller's owners the machine (connect, never takeover) and takes it from any other seller; our own team's access is never touched. Every change is audited.
 * @summary Record whether a server is ours, a customer's or a seller's
 */
export const setAdminRemoteHostOwner = async (remoteHostId: string,
    remoteHostOwnerWrite: RemoteHostOwnerWrite, options?: RequestInit): Promise<setAdminRemoteHostOwnerResponse> => {

  return orvalClient<setAdminRemoteHostOwnerResponse>(getSetAdminRemoteHostOwnerUrl(remoteHostId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remoteHostOwnerWrite)
  }
);}




export const getSetAdminRemoteHostOwnerMutationOptions = <TError = Problem | RemoteAccessErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdminRemoteHostOwner>>, TError,{remoteHostId: string;data: RemoteHostOwnerWrite}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setAdminRemoteHostOwner>>, TError,{remoteHostId: string;data: RemoteHostOwnerWrite}, TContext> => {

const mutationKey = ['setAdminRemoteHostOwner'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAdminRemoteHostOwner>>, {remoteHostId: string;data: RemoteHostOwnerWrite}> = (props) => {
          const {remoteHostId,data} = props ?? {};

          return  setAdminRemoteHostOwner(remoteHostId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetAdminRemoteHostOwnerMutationResult = NonNullable<Awaited<ReturnType<typeof setAdminRemoteHostOwner>>>
    export type SetAdminRemoteHostOwnerMutationBody = RemoteHostOwnerWrite
    export type SetAdminRemoteHostOwnerMutationError = Problem | RemoteAccessErrorResponse

    /**
 * @summary Record whether a server is ours, a customer's or a seller's
 */
export const useSetAdminRemoteHostOwner = <TError = Problem | RemoteAccessErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdminRemoteHostOwner>>, TError,{remoteHostId: string;data: RemoteHostOwnerWrite}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setAdminRemoteHostOwner>>,
        TError,
        {remoteHostId: string;data: RemoteHostOwnerWrite},
        TContext
      > => {
      return useMutation(getSetAdminRemoteHostOwnerMutationOptions(options), queryClient);
    }
    export type listAdminRemoteBoardStoreLabelsResponse200 = {
  data: RemoteBoardStoreLabelsRead
  status: 200
}

export type listAdminRemoteBoardStoreLabelsResponse403 = {
  data: Problem
  status: 403
}

export type listAdminRemoteBoardStoreLabelsResponse404 = {
  data: RemoteAccessErrorResponse
  status: 404
}

export type listAdminRemoteBoardStoreLabelsResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200 | 403 | 404>
}

export type listAdminRemoteBoardStoreLabelsResponseSuccess = (listAdminRemoteBoardStoreLabelsResponse200) & {
  headers: Headers;
};
export type listAdminRemoteBoardStoreLabelsResponseError = (listAdminRemoteBoardStoreLabelsResponse403 | listAdminRemoteBoardStoreLabelsResponse404 | listAdminRemoteBoardStoreLabelsResponseDefault) & {
  headers: Headers;
};

export type listAdminRemoteBoardStoreLabelsResponse = (listAdminRemoteBoardStoreLabelsResponseSuccess | listAdminRemoteBoardStoreLabelsResponseError)

export const getListAdminRemoteBoardStoreLabelsUrl = () => {




  return `/api/v1/admin/remote-access/host-store-labels`
}

/**
 * @summary Every reachable machine's manual store names
 */
export const listAdminRemoteBoardStoreLabels = async ( options?: RequestInit): Promise<listAdminRemoteBoardStoreLabelsResponse> => {

  return orvalClient<listAdminRemoteBoardStoreLabelsResponse>(getListAdminRemoteBoardStoreLabelsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminRemoteBoardStoreLabelsQueryKey = () => {
    return [
    `/api/v1/admin/remote-access/host-store-labels`
    ] as const;
    }


export const getListAdminRemoteBoardStoreLabelsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>, TError = Problem | RemoteAccessErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminRemoteBoardStoreLabelsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>> = ({ signal }) => listAdminRemoteBoardStoreLabels({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminRemoteBoardStoreLabelsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>>
export type ListAdminRemoteBoardStoreLabelsQueryError = Problem | RemoteAccessErrorResponse


export function useListAdminRemoteBoardStoreLabels<TData = Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>, TError = Problem | RemoteAccessErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>,
          TError,
          Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminRemoteBoardStoreLabels<TData = Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>, TError = Problem | RemoteAccessErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>,
          TError,
          Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminRemoteBoardStoreLabels<TData = Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>, TError = Problem | RemoteAccessErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every reachable machine's manual store names
 */

export function useListAdminRemoteBoardStoreLabels<TData = Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>, TError = Problem | RemoteAccessErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminRemoteBoardStoreLabelsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type listAdminRemoteBoardStoresResponse200 = {
  data: RemoteBoardStoresRead
  status: 200
}

export type listAdminRemoteBoardStoresResponse403 = {
  data: Problem
  status: 403
}

export type listAdminRemoteBoardStoresResponse404 = {
  data: RemoteAccessErrorResponse
  status: 404
}

export type listAdminRemoteBoardStoresResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200 | 403 | 404>
}

export type listAdminRemoteBoardStoresResponseSuccess = (listAdminRemoteBoardStoresResponse200) & {
  headers: Headers;
};
export type listAdminRemoteBoardStoresResponseError = (listAdminRemoteBoardStoresResponse403 | listAdminRemoteBoardStoresResponse404 | listAdminRemoteBoardStoresResponseDefault) & {
  headers: Headers;
};

export type listAdminRemoteBoardStoresResponse = (listAdminRemoteBoardStoresResponseSuccess | listAdminRemoteBoardStoresResponseError)

export const getListAdminRemoteBoardStoresUrl = () => {




  return `/api/v1/admin/remote-access/host-stores`
}

/**
 * The board names the stores under each machine, so asking per machine would cost one request per tile on every load and refresh. Machines with no links are returned with an empty list rather than omitted, so the caller can tell "none linked" apart from "not asked about".
 * @summary Every reachable machine's live store links, in one read
 */
export const listAdminRemoteBoardStores = async ( options?: RequestInit): Promise<listAdminRemoteBoardStoresResponse> => {

  return orvalClient<listAdminRemoteBoardStoresResponse>(getListAdminRemoteBoardStoresUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminRemoteBoardStoresQueryKey = () => {
    return [
    `/api/v1/admin/remote-access/host-stores`
    ] as const;
    }


export const getListAdminRemoteBoardStoresQueryOptions = <TData = Awaited<ReturnType<typeof listAdminRemoteBoardStores>>, TError = Problem | RemoteAccessErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteBoardStores>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminRemoteBoardStoresQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminRemoteBoardStores>>> = ({ signal }) => listAdminRemoteBoardStores({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteBoardStores>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminRemoteBoardStoresQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminRemoteBoardStores>>>
export type ListAdminRemoteBoardStoresQueryError = Problem | RemoteAccessErrorResponse


export function useListAdminRemoteBoardStores<TData = Awaited<ReturnType<typeof listAdminRemoteBoardStores>>, TError = Problem | RemoteAccessErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteBoardStores>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminRemoteBoardStores>>,
          TError,
          Awaited<ReturnType<typeof listAdminRemoteBoardStores>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminRemoteBoardStores<TData = Awaited<ReturnType<typeof listAdminRemoteBoardStores>>, TError = Problem | RemoteAccessErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteBoardStores>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminRemoteBoardStores>>,
          TError,
          Awaited<ReturnType<typeof listAdminRemoteBoardStores>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminRemoteBoardStores<TData = Awaited<ReturnType<typeof listAdminRemoteBoardStores>>, TError = Problem | RemoteAccessErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteBoardStores>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every reachable machine's live store links, in one read
 */

export function useListAdminRemoteBoardStores<TData = Awaited<ReturnType<typeof listAdminRemoteBoardStores>>, TError = Problem | RemoteAccessErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteBoardStores>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminRemoteBoardStoresQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type listAdminRemoteHostStoresResponse200 = {
  data: RemoteStoreLinksRead
  status: 200
}

export type listAdminRemoteHostStoresResponse403 = {
  data: Problem
  status: 403
}

export type listAdminRemoteHostStoresResponse404 = {
  data: RemoteAccessErrorResponse
  status: 404
}

export type listAdminRemoteHostStoresResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200 | 403 | 404>
}

export type listAdminRemoteHostStoresResponseSuccess = (listAdminRemoteHostStoresResponse200) & {
  headers: Headers;
};
export type listAdminRemoteHostStoresResponseError = (listAdminRemoteHostStoresResponse403 | listAdminRemoteHostStoresResponse404 | listAdminRemoteHostStoresResponseDefault) & {
  headers: Headers;
};

export type listAdminRemoteHostStoresResponse = (listAdminRemoteHostStoresResponseSuccess | listAdminRemoteHostStoresResponseError)

export const getListAdminRemoteHostStoresUrl = (remoteHostId: string,) => {




  return `/api/v1/admin/remote-access/hosts/${remoteHostId}/stores`
}

/**
 * Reads the live links only. A retired link stays in the database so the period it was in force remains answerable, but it is not reported here. A machine looks after several stores, and each store is recorded against one machine. This is a record of a decision taken outside the platform, not an enforcement of it.
 * @summary Stores this workstation is looking after
 */
export const listAdminRemoteHostStores = async (remoteHostId: string, options?: RequestInit): Promise<listAdminRemoteHostStoresResponse> => {

  return orvalClient<listAdminRemoteHostStoresResponse>(getListAdminRemoteHostStoresUrl(remoteHostId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminRemoteHostStoresQueryKey = (remoteHostId: string,) => {
    return [
    `/api/v1/admin/remote-access/hosts/${remoteHostId}/stores`
    ] as const;
    }


export const getListAdminRemoteHostStoresQueryOptions = <TData = Awaited<ReturnType<typeof listAdminRemoteHostStores>>, TError = Problem | RemoteAccessErrorResponse>(remoteHostId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostStores>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminRemoteHostStoresQueryKey(remoteHostId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminRemoteHostStores>>> = ({ signal }) => listAdminRemoteHostStores(remoteHostId, { signal });





   return  { queryKey, queryFn, enabled: remoteHostId !== null && remoteHostId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostStores>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminRemoteHostStoresQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminRemoteHostStores>>>
export type ListAdminRemoteHostStoresQueryError = Problem | RemoteAccessErrorResponse


export function useListAdminRemoteHostStores<TData = Awaited<ReturnType<typeof listAdminRemoteHostStores>>, TError = Problem | RemoteAccessErrorResponse>(
 remoteHostId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostStores>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminRemoteHostStores>>,
          TError,
          Awaited<ReturnType<typeof listAdminRemoteHostStores>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminRemoteHostStores<TData = Awaited<ReturnType<typeof listAdminRemoteHostStores>>, TError = Problem | RemoteAccessErrorResponse>(
 remoteHostId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostStores>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminRemoteHostStores>>,
          TError,
          Awaited<ReturnType<typeof listAdminRemoteHostStores>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminRemoteHostStores<TData = Awaited<ReturnType<typeof listAdminRemoteHostStores>>, TError = Problem | RemoteAccessErrorResponse>(
 remoteHostId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostStores>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Stores this workstation is looking after
 */

export function useListAdminRemoteHostStores<TData = Awaited<ReturnType<typeof listAdminRemoteHostStores>>, TError = Problem | RemoteAccessErrorResponse>(
 remoteHostId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostStores>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminRemoteHostStoresQueryOptions(remoteHostId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type linkAdminRemoteHostStoreResponse201 = {
  data: RemoteStoreLinkRead
  status: 201
}

export type linkAdminRemoteHostStoreResponse403 = {
  data: Problem
  status: 403
}

export type linkAdminRemoteHostStoreResponse404 = {
  data: RemoteAccessErrorResponse
  status: 404
}

export type linkAdminRemoteHostStoreResponse409 = {
  data: RemoteAccessErrorResponse
  status: 409
}

export type linkAdminRemoteHostStoreResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 201 | 403 | 404 | 409>
}

export type linkAdminRemoteHostStoreResponseSuccess = (linkAdminRemoteHostStoreResponse201) & {
  headers: Headers;
};
export type linkAdminRemoteHostStoreResponseError = (linkAdminRemoteHostStoreResponse403 | linkAdminRemoteHostStoreResponse404 | linkAdminRemoteHostStoreResponse409 | linkAdminRemoteHostStoreResponseDefault) & {
  headers: Headers;
};

export type linkAdminRemoteHostStoreResponse = (linkAdminRemoteHostStoreResponseSuccess | linkAdminRemoteHostStoreResponseError)

export const getLinkAdminRemoteHostStoreUrl = (remoteHostId: string,) => {




  return `/api/v1/admin/remote-access/hosts/${remoteHostId}/stores`
}

/**
 * Records an operational fact. Grants nobody access to anything; who may connect to the server is still decided by assignment alone. A store outside the organisation the admin is acting in answers 404, so the reply cannot confirm that another tenant owns it. A store already recorded on another machine is refused here, so the record cannot say a shop is in two places. Moving the record is a deliberate two-step — retire the old link, then make this one. This records a decision taken elsewhere; it opens no shop and prevents nobody from opening one, which happens in a browser inside the remote session.
 * @summary Say this workstation looks after one more store
 */
export const linkAdminRemoteHostStore = async (remoteHostId: string,
    remoteStoreLinkWrite: RemoteStoreLinkWrite, options?: RequestInit): Promise<linkAdminRemoteHostStoreResponse> => {

  return orvalClient<linkAdminRemoteHostStoreResponse>(getLinkAdminRemoteHostStoreUrl(remoteHostId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remoteStoreLinkWrite)
  }
);}




export const getLinkAdminRemoteHostStoreMutationOptions = <TError = Problem | RemoteAccessErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkAdminRemoteHostStore>>, TError,{remoteHostId: string;data: RemoteStoreLinkWrite}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof linkAdminRemoteHostStore>>, TError,{remoteHostId: string;data: RemoteStoreLinkWrite}, TContext> => {

const mutationKey = ['linkAdminRemoteHostStore'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof linkAdminRemoteHostStore>>, {remoteHostId: string;data: RemoteStoreLinkWrite}> = (props) => {
          const {remoteHostId,data} = props ?? {};

          return  linkAdminRemoteHostStore(remoteHostId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LinkAdminRemoteHostStoreMutationResult = NonNullable<Awaited<ReturnType<typeof linkAdminRemoteHostStore>>>
    export type LinkAdminRemoteHostStoreMutationBody = RemoteStoreLinkWrite
    export type LinkAdminRemoteHostStoreMutationError = Problem | RemoteAccessErrorResponse

    /**
 * @summary Say this workstation looks after one more store
 */
export const useLinkAdminRemoteHostStore = <TError = Problem | RemoteAccessErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkAdminRemoteHostStore>>, TError,{remoteHostId: string;data: RemoteStoreLinkWrite}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof linkAdminRemoteHostStore>>,
        TError,
        {remoteHostId: string;data: RemoteStoreLinkWrite},
        TContext
      > => {
      return useMutation(getLinkAdminRemoteHostStoreMutationOptions(options), queryClient);
    }
    export type listAdminRemoteHostStoreLabelsResponse200 = {
  data: RemoteStoreLabelsRead
  status: 200
}

export type listAdminRemoteHostStoreLabelsResponse403 = {
  data: Problem
  status: 403
}

export type listAdminRemoteHostStoreLabelsResponse404 = {
  data: RemoteAccessErrorResponse
  status: 404
}

export type listAdminRemoteHostStoreLabelsResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200 | 403 | 404>
}

export type listAdminRemoteHostStoreLabelsResponseSuccess = (listAdminRemoteHostStoreLabelsResponse200) & {
  headers: Headers;
};
export type listAdminRemoteHostStoreLabelsResponseError = (listAdminRemoteHostStoreLabelsResponse403 | listAdminRemoteHostStoreLabelsResponse404 | listAdminRemoteHostStoreLabelsResponseDefault) & {
  headers: Headers;
};

export type listAdminRemoteHostStoreLabelsResponse = (listAdminRemoteHostStoreLabelsResponseSuccess | listAdminRemoteHostStoreLabelsResponseError)

export const getListAdminRemoteHostStoreLabelsUrl = (remoteHostId: string,) => {




  return `/api/v1/admin/remote-access/hosts/${remoteHostId}/store-labels`
}

/**
 * @summary Manual store names assigned to this workstation
 */
export const listAdminRemoteHostStoreLabels = async (remoteHostId: string, options?: RequestInit): Promise<listAdminRemoteHostStoreLabelsResponse> => {

  return orvalClient<listAdminRemoteHostStoreLabelsResponse>(getListAdminRemoteHostStoreLabelsUrl(remoteHostId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminRemoteHostStoreLabelsQueryKey = (remoteHostId: string,) => {
    return [
    `/api/v1/admin/remote-access/hosts/${remoteHostId}/store-labels`
    ] as const;
    }


export const getListAdminRemoteHostStoreLabelsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>, TError = Problem | RemoteAccessErrorResponse>(remoteHostId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminRemoteHostStoreLabelsQueryKey(remoteHostId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>> = ({ signal }) => listAdminRemoteHostStoreLabels(remoteHostId, { signal });





   return  { queryKey, queryFn, enabled: remoteHostId !== null && remoteHostId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminRemoteHostStoreLabelsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>>
export type ListAdminRemoteHostStoreLabelsQueryError = Problem | RemoteAccessErrorResponse


export function useListAdminRemoteHostStoreLabels<TData = Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>, TError = Problem | RemoteAccessErrorResponse>(
 remoteHostId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>,
          TError,
          Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminRemoteHostStoreLabels<TData = Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>, TError = Problem | RemoteAccessErrorResponse>(
 remoteHostId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>,
          TError,
          Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminRemoteHostStoreLabels<TData = Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>, TError = Problem | RemoteAccessErrorResponse>(
 remoteHostId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Manual store names assigned to this workstation
 */

export function useListAdminRemoteHostStoreLabels<TData = Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>, TError = Problem | RemoteAccessErrorResponse>(
 remoteHostId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminRemoteHostStoreLabelsQueryOptions(remoteHostId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type assignAdminRemoteHostStoreLabelResponse201 = {
  data: RemoteStoreLabelRead
  status: 201
}

export type assignAdminRemoteHostStoreLabelResponse403 = {
  data: Problem
  status: 403
}

export type assignAdminRemoteHostStoreLabelResponse404 = {
  data: RemoteAccessErrorResponse
  status: 404
}

export type assignAdminRemoteHostStoreLabelResponse409 = {
  data: RemoteAccessErrorResponse
  status: 409
}

export type assignAdminRemoteHostStoreLabelResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 201 | 403 | 404 | 409>
}

export type assignAdminRemoteHostStoreLabelResponseSuccess = (assignAdminRemoteHostStoreLabelResponse201) & {
  headers: Headers;
};
export type assignAdminRemoteHostStoreLabelResponseError = (assignAdminRemoteHostStoreLabelResponse403 | assignAdminRemoteHostStoreLabelResponse404 | assignAdminRemoteHostStoreLabelResponse409 | assignAdminRemoteHostStoreLabelResponseDefault) & {
  headers: Headers;
};

export type assignAdminRemoteHostStoreLabelResponse = (assignAdminRemoteHostStoreLabelResponseSuccess | assignAdminRemoteHostStoreLabelResponseError)

export const getAssignAdminRemoteHostStoreLabelUrl = (remoteHostId: string,) => {




  return `/api/v1/admin/remote-access/hosts/${remoteHostId}/store-labels`
}

/**
 * Records operational context only; it creates no commerce integration and grants no remote access.
 * @summary Assign a free-form store name to this workstation
 */
export const assignAdminRemoteHostStoreLabel = async (remoteHostId: string,
    remoteStoreLabelWrite: RemoteStoreLabelWrite, options?: RequestInit): Promise<assignAdminRemoteHostStoreLabelResponse> => {

  return orvalClient<assignAdminRemoteHostStoreLabelResponse>(getAssignAdminRemoteHostStoreLabelUrl(remoteHostId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remoteStoreLabelWrite)
  }
);}




export const getAssignAdminRemoteHostStoreLabelMutationOptions = <TError = Problem | RemoteAccessErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignAdminRemoteHostStoreLabel>>, TError,{remoteHostId: string;data: RemoteStoreLabelWrite}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof assignAdminRemoteHostStoreLabel>>, TError,{remoteHostId: string;data: RemoteStoreLabelWrite}, TContext> => {

const mutationKey = ['assignAdminRemoteHostStoreLabel'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignAdminRemoteHostStoreLabel>>, {remoteHostId: string;data: RemoteStoreLabelWrite}> = (props) => {
          const {remoteHostId,data} = props ?? {};

          return  assignAdminRemoteHostStoreLabel(remoteHostId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignAdminRemoteHostStoreLabelMutationResult = NonNullable<Awaited<ReturnType<typeof assignAdminRemoteHostStoreLabel>>>
    export type AssignAdminRemoteHostStoreLabelMutationBody = RemoteStoreLabelWrite
    export type AssignAdminRemoteHostStoreLabelMutationError = Problem | RemoteAccessErrorResponse

    /**
 * @summary Assign a free-form store name to this workstation
 */
export const useAssignAdminRemoteHostStoreLabel = <TError = Problem | RemoteAccessErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignAdminRemoteHostStoreLabel>>, TError,{remoteHostId: string;data: RemoteStoreLabelWrite}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assignAdminRemoteHostStoreLabel>>,
        TError,
        {remoteHostId: string;data: RemoteStoreLabelWrite},
        TContext
      > => {
      return useMutation(getAssignAdminRemoteHostStoreLabelMutationOptions(options), queryClient);
    }
    export type removeAdminRemoteHostStoreLabelResponse204 = {
  data: void
  status: 204
}

export type removeAdminRemoteHostStoreLabelResponse403 = {
  data: Problem
  status: 403
}

export type removeAdminRemoteHostStoreLabelResponse404 = {
  data: RemoteAccessErrorResponse
  status: 404
}

export type removeAdminRemoteHostStoreLabelResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 204 | 403 | 404>
}

export type removeAdminRemoteHostStoreLabelResponseSuccess = (removeAdminRemoteHostStoreLabelResponse204) & {
  headers: Headers;
};
export type removeAdminRemoteHostStoreLabelResponseError = (removeAdminRemoteHostStoreLabelResponse403 | removeAdminRemoteHostStoreLabelResponse404 | removeAdminRemoteHostStoreLabelResponseDefault) & {
  headers: Headers;
};

export type removeAdminRemoteHostStoreLabelResponse = (removeAdminRemoteHostStoreLabelResponseSuccess | removeAdminRemoteHostStoreLabelResponseError)

export const getRemoveAdminRemoteHostStoreLabelUrl = (remoteHostId: string,
    labelId: string,) => {




  return `/api/v1/admin/remote-access/hosts/${remoteHostId}/store-labels/${labelId}`
}

/**
 * Retires the assignment rather than deleting its audit history.
 * @summary Remove a manual store name from this workstation
 */
export const removeAdminRemoteHostStoreLabel = async (remoteHostId: string,
    labelId: string, options?: RequestInit): Promise<removeAdminRemoteHostStoreLabelResponse> => {

  return orvalClient<removeAdminRemoteHostStoreLabelResponse>(getRemoveAdminRemoteHostStoreLabelUrl(remoteHostId,labelId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getRemoveAdminRemoteHostStoreLabelMutationOptions = <TError = Problem | RemoteAccessErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAdminRemoteHostStoreLabel>>, TError,{remoteHostId: string;labelId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof removeAdminRemoteHostStoreLabel>>, TError,{remoteHostId: string;labelId: string}, TContext> => {

const mutationKey = ['removeAdminRemoteHostStoreLabel'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeAdminRemoteHostStoreLabel>>, {remoteHostId: string;labelId: string}> = (props) => {
          const {remoteHostId,labelId} = props ?? {};

          return  removeAdminRemoteHostStoreLabel(remoteHostId,labelId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveAdminRemoteHostStoreLabelMutationResult = NonNullable<Awaited<ReturnType<typeof removeAdminRemoteHostStoreLabel>>>

    export type RemoveAdminRemoteHostStoreLabelMutationError = Problem | RemoteAccessErrorResponse

    /**
 * @summary Remove a manual store name from this workstation
 */
export const useRemoveAdminRemoteHostStoreLabel = <TError = Problem | RemoteAccessErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAdminRemoteHostStoreLabel>>, TError,{remoteHostId: string;labelId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeAdminRemoteHostStoreLabel>>,
        TError,
        {remoteHostId: string;labelId: string},
        TContext
      > => {
      return useMutation(getRemoveAdminRemoteHostStoreLabelMutationOptions(options), queryClient);
    }
    export type listAdminStoreProductGroupsResponse200 = {
  data: StoreProductGroupsRead
  status: 200
}

export type listAdminStoreProductGroupsResponse403 = {
  data: Problem
  status: 403
}

export type listAdminStoreProductGroupsResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200 | 403>
}

export type listAdminStoreProductGroupsResponseSuccess = (listAdminStoreProductGroupsResponse200) & {
  headers: Headers;
};
export type listAdminStoreProductGroupsResponseError = (listAdminStoreProductGroupsResponse403 | listAdminStoreProductGroupsResponseDefault) & {
  headers: Headers;
};

export type listAdminStoreProductGroupsResponse = (listAdminStoreProductGroupsResponseSuccess | listAdminStoreProductGroupsResponseError)

export const getListAdminStoreProductGroupsUrl = () => {




  return `/api/v1/admin/remote-access/store-product-groups`
}

/**
 * Independent of the remote-access pilot rollout — this reads store assortment, not machine assignment, so every admin with remote_access.view sees every internal (BO1) store here regardless of which (if any) machine looks after it.
 * @summary Every internal store with its live product-group tags
 */
export const listAdminStoreProductGroups = async ( options?: RequestInit): Promise<listAdminStoreProductGroupsResponse> => {

  return orvalClient<listAdminStoreProductGroupsResponse>(getListAdminStoreProductGroupsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminStoreProductGroupsQueryKey = () => {
    return [
    `/api/v1/admin/remote-access/store-product-groups`
    ] as const;
    }


export const getListAdminStoreProductGroupsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminStoreProductGroups>>, TError = Problem>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminStoreProductGroups>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminStoreProductGroupsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminStoreProductGroups>>> = ({ signal }) => listAdminStoreProductGroups({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminStoreProductGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminStoreProductGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminStoreProductGroups>>>
export type ListAdminStoreProductGroupsQueryError = Problem


export function useListAdminStoreProductGroups<TData = Awaited<ReturnType<typeof listAdminStoreProductGroups>>, TError = Problem>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminStoreProductGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminStoreProductGroups>>,
          TError,
          Awaited<ReturnType<typeof listAdminStoreProductGroups>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminStoreProductGroups<TData = Awaited<ReturnType<typeof listAdminStoreProductGroups>>, TError = Problem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminStoreProductGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminStoreProductGroups>>,
          TError,
          Awaited<ReturnType<typeof listAdminStoreProductGroups>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminStoreProductGroups<TData = Awaited<ReturnType<typeof listAdminStoreProductGroups>>, TError = Problem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminStoreProductGroups>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every internal store with its live product-group tags
 */

export function useListAdminStoreProductGroups<TData = Awaited<ReturnType<typeof listAdminStoreProductGroups>>, TError = Problem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminStoreProductGroups>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminStoreProductGroupsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type assignAdminStoreProductGroupResponse201 = {
  data: StoreProductGroupRead
  status: 201
}

export type assignAdminStoreProductGroupResponse403 = {
  data: Problem
  status: 403
}

export type assignAdminStoreProductGroupResponse404 = {
  data: RemoteAccessErrorResponse
  status: 404
}

export type assignAdminStoreProductGroupResponse409 = {
  data: RemoteAccessErrorResponse
  status: 409
}

export type assignAdminStoreProductGroupResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 201 | 403 | 404 | 409>
}

export type assignAdminStoreProductGroupResponseSuccess = (assignAdminStoreProductGroupResponse201) & {
  headers: Headers;
};
export type assignAdminStoreProductGroupResponseError = (assignAdminStoreProductGroupResponse403 | assignAdminStoreProductGroupResponse404 | assignAdminStoreProductGroupResponse409 | assignAdminStoreProductGroupResponseDefault) & {
  headers: Headers;
};

export type assignAdminStoreProductGroupResponse = (assignAdminStoreProductGroupResponseSuccess | assignAdminStoreProductGroupResponseError)

export const getAssignAdminStoreProductGroupUrl = () => {




  return `/api/v1/admin/remote-access/store-product-groups`
}

/**
 * A free-form tag, not a catalog binding. The same tag text may repeat across many stores — that repetition is how two stores are seen to sell the same product group. A store outside the internal (BO1) fleet answers 404.
 * @summary Tag one internal store with a product group it sells
 */
export const assignAdminStoreProductGroup = async (storeProductGroupWrite: StoreProductGroupWrite, options?: RequestInit): Promise<assignAdminStoreProductGroupResponse> => {

  return orvalClient<assignAdminStoreProductGroupResponse>(getAssignAdminStoreProductGroupUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(storeProductGroupWrite)
  }
);}




export const getAssignAdminStoreProductGroupMutationOptions = <TError = Problem | RemoteAccessErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignAdminStoreProductGroup>>, TError,{data: StoreProductGroupWrite}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof assignAdminStoreProductGroup>>, TError,{data: StoreProductGroupWrite}, TContext> => {

const mutationKey = ['assignAdminStoreProductGroup'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignAdminStoreProductGroup>>, {data: StoreProductGroupWrite}> = (props) => {
          const {data} = props ?? {};

          return  assignAdminStoreProductGroup(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignAdminStoreProductGroupMutationResult = NonNullable<Awaited<ReturnType<typeof assignAdminStoreProductGroup>>>
    export type AssignAdminStoreProductGroupMutationBody = StoreProductGroupWrite
    export type AssignAdminStoreProductGroupMutationError = Problem | RemoteAccessErrorResponse

    /**
 * @summary Tag one internal store with a product group it sells
 */
export const useAssignAdminStoreProductGroup = <TError = Problem | RemoteAccessErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignAdminStoreProductGroup>>, TError,{data: StoreProductGroupWrite}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assignAdminStoreProductGroup>>,
        TError,
        {data: StoreProductGroupWrite},
        TContext
      > => {
      return useMutation(getAssignAdminStoreProductGroupMutationOptions(options), queryClient);
    }
    export type removeAdminStoreProductGroupResponse204 = {
  data: void
  status: 204
}

export type removeAdminStoreProductGroupResponse403 = {
  data: Problem
  status: 403
}

export type removeAdminStoreProductGroupResponse404 = {
  data: RemoteAccessErrorResponse
  status: 404
}

export type removeAdminStoreProductGroupResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 204 | 403 | 404>
}

export type removeAdminStoreProductGroupResponseSuccess = (removeAdminStoreProductGroupResponse204) & {
  headers: Headers;
};
export type removeAdminStoreProductGroupResponseError = (removeAdminStoreProductGroupResponse403 | removeAdminStoreProductGroupResponse404 | removeAdminStoreProductGroupResponseDefault) & {
  headers: Headers;
};

export type removeAdminStoreProductGroupResponse = (removeAdminStoreProductGroupResponseSuccess | removeAdminStoreProductGroupResponseError)

export const getRemoveAdminStoreProductGroupUrl = (groupId: string,) => {




  return `/api/v1/admin/remote-access/store-product-groups/${groupId}`
}

/**
 * Retires the tag rather than deleting its audit history.
 * @summary Remove a product-group tag from an internal store
 */
export const removeAdminStoreProductGroup = async (groupId: string, options?: RequestInit): Promise<removeAdminStoreProductGroupResponse> => {

  return orvalClient<removeAdminStoreProductGroupResponse>(getRemoveAdminStoreProductGroupUrl(groupId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getRemoveAdminStoreProductGroupMutationOptions = <TError = Problem | RemoteAccessErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAdminStoreProductGroup>>, TError,{groupId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof removeAdminStoreProductGroup>>, TError,{groupId: string}, TContext> => {

const mutationKey = ['removeAdminStoreProductGroup'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeAdminStoreProductGroup>>, {groupId: string}> = (props) => {
          const {groupId} = props ?? {};

          return  removeAdminStoreProductGroup(groupId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveAdminStoreProductGroupMutationResult = NonNullable<Awaited<ReturnType<typeof removeAdminStoreProductGroup>>>

    export type RemoveAdminStoreProductGroupMutationError = Problem | RemoteAccessErrorResponse

    /**
 * @summary Remove a product-group tag from an internal store
 */
export const useRemoveAdminStoreProductGroup = <TError = Problem | RemoteAccessErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAdminStoreProductGroup>>, TError,{groupId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeAdminStoreProductGroup>>,
        TError,
        {groupId: string},
        TContext
      > => {
      return useMutation(getRemoveAdminStoreProductGroupMutationOptions(options), queryClient);
    }
    export type listAdminRemoteHostLinkableStoresResponse200 = {
  data: RemoteLinkableStoresRead
  status: 200
}

export type listAdminRemoteHostLinkableStoresResponse403 = {
  data: Problem
  status: 403
}

export type listAdminRemoteHostLinkableStoresResponse404 = {
  data: RemoteAccessErrorResponse
  status: 404
}

export type listAdminRemoteHostLinkableStoresResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200 | 403 | 404>
}

export type listAdminRemoteHostLinkableStoresResponseSuccess = (listAdminRemoteHostLinkableStoresResponse200) & {
  headers: Headers;
};
export type listAdminRemoteHostLinkableStoresResponseError = (listAdminRemoteHostLinkableStoresResponse403 | listAdminRemoteHostLinkableStoresResponse404 | listAdminRemoteHostLinkableStoresResponseDefault) & {
  headers: Headers;
};

export type listAdminRemoteHostLinkableStoresResponse = (listAdminRemoteHostLinkableStoresResponseSuccess | listAdminRemoteHostLinkableStoresResponseError)

export const getListAdminRemoteHostLinkableStoresUrl = (remoteHostId: string,) => {




  return `/api/v1/admin/remote-access/hosts/${remoteHostId}/linkable-stores`
}

/**
 * Scoped to the organisation the admin is acting in, and excluding every store already recorded on any machine — not merely on this one — so the board cannot write a record claiming a shop is in two places. The scope is the acting membership's own organisation, never a preference for the platform owner.
 * @summary Stores that may still be linked to this workstation
 */
export const listAdminRemoteHostLinkableStores = async (remoteHostId: string, options?: RequestInit): Promise<listAdminRemoteHostLinkableStoresResponse> => {

  return orvalClient<listAdminRemoteHostLinkableStoresResponse>(getListAdminRemoteHostLinkableStoresUrl(remoteHostId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminRemoteHostLinkableStoresQueryKey = (remoteHostId: string,) => {
    return [
    `/api/v1/admin/remote-access/hosts/${remoteHostId}/linkable-stores`
    ] as const;
    }


export const getListAdminRemoteHostLinkableStoresQueryOptions = <TData = Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>, TError = Problem | RemoteAccessErrorResponse>(remoteHostId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminRemoteHostLinkableStoresQueryKey(remoteHostId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>> = ({ signal }) => listAdminRemoteHostLinkableStores(remoteHostId, { signal });





   return  { queryKey, queryFn, enabled: remoteHostId !== null && remoteHostId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminRemoteHostLinkableStoresQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>>
export type ListAdminRemoteHostLinkableStoresQueryError = Problem | RemoteAccessErrorResponse


export function useListAdminRemoteHostLinkableStores<TData = Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>, TError = Problem | RemoteAccessErrorResponse>(
 remoteHostId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>,
          TError,
          Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminRemoteHostLinkableStores<TData = Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>, TError = Problem | RemoteAccessErrorResponse>(
 remoteHostId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>,
          TError,
          Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminRemoteHostLinkableStores<TData = Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>, TError = Problem | RemoteAccessErrorResponse>(
 remoteHostId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Stores that may still be linked to this workstation
 */

export function useListAdminRemoteHostLinkableStores<TData = Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>, TError = Problem | RemoteAccessErrorResponse>(
 remoteHostId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminRemoteHostLinkableStoresQueryOptions(remoteHostId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type unlinkAdminRemoteHostStoreResponse204 = {
  data: void
  status: 204
}

export type unlinkAdminRemoteHostStoreResponse403 = {
  data: Problem
  status: 403
}

export type unlinkAdminRemoteHostStoreResponse404 = {
  data: RemoteAccessErrorResponse
  status: 404
}

export type unlinkAdminRemoteHostStoreResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 204 | 403 | 404>
}

export type unlinkAdminRemoteHostStoreResponseSuccess = (unlinkAdminRemoteHostStoreResponse204) & {
  headers: Headers;
};
export type unlinkAdminRemoteHostStoreResponseError = (unlinkAdminRemoteHostStoreResponse403 | unlinkAdminRemoteHostStoreResponse404 | unlinkAdminRemoteHostStoreResponseDefault) & {
  headers: Headers;
};

export type unlinkAdminRemoteHostStoreResponse = (unlinkAdminRemoteHostStoreResponseSuccess | unlinkAdminRemoteHostStoreResponseError)

export const getUnlinkAdminRemoteHostStoreUrl = (remoteHostId: string,
    linkId: string,) => {




  return `/api/v1/admin/remote-access/hosts/${remoteHostId}/stores/${linkId}`
}

/**
 * Retires the link rather than deleting it, so the period it was in force stays readable after the fact.
 * @summary Stop saying this workstation looks after that store
 */
export const unlinkAdminRemoteHostStore = async (remoteHostId: string,
    linkId: string, options?: RequestInit): Promise<unlinkAdminRemoteHostStoreResponse> => {

  return orvalClient<unlinkAdminRemoteHostStoreResponse>(getUnlinkAdminRemoteHostStoreUrl(remoteHostId,linkId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getUnlinkAdminRemoteHostStoreMutationOptions = <TError = Problem | RemoteAccessErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlinkAdminRemoteHostStore>>, TError,{remoteHostId: string;linkId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof unlinkAdminRemoteHostStore>>, TError,{remoteHostId: string;linkId: string}, TContext> => {

const mutationKey = ['unlinkAdminRemoteHostStore'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unlinkAdminRemoteHostStore>>, {remoteHostId: string;linkId: string}> = (props) => {
          const {remoteHostId,linkId} = props ?? {};

          return  unlinkAdminRemoteHostStore(remoteHostId,linkId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnlinkAdminRemoteHostStoreMutationResult = NonNullable<Awaited<ReturnType<typeof unlinkAdminRemoteHostStore>>>

    export type UnlinkAdminRemoteHostStoreMutationError = Problem | RemoteAccessErrorResponse

    /**
 * @summary Stop saying this workstation looks after that store
 */
export const useUnlinkAdminRemoteHostStore = <TError = Problem | RemoteAccessErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlinkAdminRemoteHostStore>>, TError,{remoteHostId: string;linkId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unlinkAdminRemoteHostStore>>,
        TError,
        {remoteHostId: string;linkId: string},
        TContext
      > => {
      return useMutation(getUnlinkAdminRemoteHostStoreMutationOptions(options), queryClient);
    }
    export type createAdminRemoteLaunchResponse200 = {
  data: RemoteLaunchIntent
  status: 200
}

export type createAdminRemoteLaunchResponse403 = {
  data: Problem
  status: 403
}

export type createAdminRemoteLaunchResponse409 = {
  data: RemoteLaunchReplayResponse | RemoteAccessErrorResponse
  status: 409
}

export type createAdminRemoteLaunchResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200 | 403 | 409>
}

export type createAdminRemoteLaunchResponseSuccess = (createAdminRemoteLaunchResponse200) & {
  headers: Headers;
};
export type createAdminRemoteLaunchResponseError = (createAdminRemoteLaunchResponse403 | createAdminRemoteLaunchResponse409 | createAdminRemoteLaunchResponseDefault) & {
  headers: Headers;
};

export type createAdminRemoteLaunchResponse = (createAdminRemoteLaunchResponseSuccess | createAdminRemoteLaunchResponseError)

export const getCreateAdminRemoteLaunchUrl = (remoteHostId: string,) => {




  return `/api/v1/admin/remote-access/hosts/${remoteHostId}/launch`
}

/**
 * A new operation returns a body-only 60-second PEXIFY ticket for a top-level form POST to the separate bridge origin. An exact replay returns only its safe session/status locator and never reissues the ticket. The ticket is never a URL, cookie, or browser-storage value.
 * @summary Create an idempotent one-use Remote Access launch intent or locate its replay
 */
export const createAdminRemoteLaunch = async (remoteHostId: string, options?: RequestInit): Promise<createAdminRemoteLaunchResponse> => {

  return orvalClient<createAdminRemoteLaunchResponse>(getCreateAdminRemoteLaunchUrl(remoteHostId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCreateAdminRemoteLaunchMutationOptions = <TError = Problem | RemoteLaunchReplayResponse | RemoteAccessErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminRemoteLaunch>>, TError,{remoteHostId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAdminRemoteLaunch>>, TError,{remoteHostId: string}, TContext> => {

const mutationKey = ['createAdminRemoteLaunch'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAdminRemoteLaunch>>, {remoteHostId: string}> = (props) => {
          const {remoteHostId} = props ?? {};

          return  createAdminRemoteLaunch(remoteHostId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAdminRemoteLaunchMutationResult = NonNullable<Awaited<ReturnType<typeof createAdminRemoteLaunch>>>

    export type CreateAdminRemoteLaunchMutationError = Problem | RemoteLaunchReplayResponse | RemoteAccessErrorResponse

    /**
 * @summary Create an idempotent one-use Remote Access launch intent or locate its replay
 */
export const useCreateAdminRemoteLaunch = <TError = Problem | RemoteLaunchReplayResponse | RemoteAccessErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminRemoteLaunch>>, TError,{remoteHostId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAdminRemoteLaunch>>,
        TError,
        {remoteHostId: string},
        TContext
      > => {
      return useMutation(getCreateAdminRemoteLaunchMutationOptions(options), queryClient);
    }
    export type listAdminRemoteSellerOrgsResponse200 = {
  data: RemoteSellerOrgsRead
  status: 200
}

export type listAdminRemoteSellerOrgsResponse403 = {
  data: Problem
  status: 403
}

export type listAdminRemoteSellerOrgsResponseSuccess = (listAdminRemoteSellerOrgsResponse200) & {
  headers: Headers;
};
export type listAdminRemoteSellerOrgsResponseError = (listAdminRemoteSellerOrgsResponse403) & {
  headers: Headers;
};

export type listAdminRemoteSellerOrgsResponse = (listAdminRemoteSellerOrgsResponseSuccess | listAdminRemoteSellerOrgsResponseError)

export const getListAdminRemoteSellerOrgsUrl = () => {




  return `/api/v1/admin/remote-access/seller-orgs`
}

/**
 * @summary List the sellers a customer machine can be given to
 */
export const listAdminRemoteSellerOrgs = async ( options?: RequestInit): Promise<listAdminRemoteSellerOrgsResponse> => {

  return orvalClient<listAdminRemoteSellerOrgsResponse>(getListAdminRemoteSellerOrgsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminRemoteSellerOrgsQueryKey = () => {
    return [
    `/api/v1/admin/remote-access/seller-orgs`
    ] as const;
    }


export const getListAdminRemoteSellerOrgsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>, TError = Problem>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminRemoteSellerOrgsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>> = ({ signal }) => listAdminRemoteSellerOrgs({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminRemoteSellerOrgsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>>
export type ListAdminRemoteSellerOrgsQueryError = Problem


export function useListAdminRemoteSellerOrgs<TData = Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>, TError = Problem>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>,
          TError,
          Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminRemoteSellerOrgs<TData = Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>, TError = Problem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>,
          TError,
          Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminRemoteSellerOrgs<TData = Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>, TError = Problem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the sellers a customer machine can be given to
 */

export function useListAdminRemoteSellerOrgs<TData = Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>, TError = Problem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminRemoteSellerOrgsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type getAdminRemoteSessionResponse200 = {
  data: RemoteSessionRead
  status: 200
}

export type getAdminRemoteSessionResponse403 = {
  data: Problem
  status: 403
}

export type getAdminRemoteSessionResponse404 = {
  data: Problem
  status: 404
}

export type getAdminRemoteSessionResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200 | 403 | 404>
}

export type getAdminRemoteSessionResponseSuccess = (getAdminRemoteSessionResponse200) & {
  headers: Headers;
};
export type getAdminRemoteSessionResponseError = (getAdminRemoteSessionResponse403 | getAdminRemoteSessionResponse404 | getAdminRemoteSessionResponseDefault) & {
  headers: Headers;
};

export type getAdminRemoteSessionResponse = (getAdminRemoteSessionResponseSuccess | getAdminRemoteSessionResponseError)

export const getGetAdminRemoteSessionUrl = (sessionId: string,) => {




  return `/api/v1/admin/remote-access/sessions/${sessionId}`
}

/**
 * @summary Read safe status for one Remote Access session
 */
export const getAdminRemoteSession = async (sessionId: string, options?: RequestInit): Promise<getAdminRemoteSessionResponse> => {

  return orvalClient<getAdminRemoteSessionResponse>(getGetAdminRemoteSessionUrl(sessionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminRemoteSessionQueryKey = (sessionId: string,) => {
    return [
    `/api/v1/admin/remote-access/sessions/${sessionId}`
    ] as const;
    }


export const getGetAdminRemoteSessionQueryOptions = <TData = Awaited<ReturnType<typeof getAdminRemoteSession>>, TError = Problem>(sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRemoteSession>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminRemoteSessionQueryKey(sessionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminRemoteSession>>> = ({ signal }) => getAdminRemoteSession(sessionId, { signal });





   return  { queryKey, queryFn, enabled: sessionId !== null && sessionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminRemoteSession>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminRemoteSessionQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminRemoteSession>>>
export type GetAdminRemoteSessionQueryError = Problem


export function useGetAdminRemoteSession<TData = Awaited<ReturnType<typeof getAdminRemoteSession>>, TError = Problem>(
 sessionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRemoteSession>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminRemoteSession>>,
          TError,
          Awaited<ReturnType<typeof getAdminRemoteSession>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminRemoteSession<TData = Awaited<ReturnType<typeof getAdminRemoteSession>>, TError = Problem>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRemoteSession>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminRemoteSession>>,
          TError,
          Awaited<ReturnType<typeof getAdminRemoteSession>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminRemoteSession<TData = Awaited<ReturnType<typeof getAdminRemoteSession>>, TError = Problem>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRemoteSession>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read safe status for one Remote Access session
 */

export function useGetAdminRemoteSession<TData = Awaited<ReturnType<typeof getAdminRemoteSession>>, TError = Problem>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRemoteSession>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminRemoteSessionQueryOptions(sessionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type closeAdminRemoteSessionResponse200 = {
  data: RemoteSessionRead
  status: 200
}

export type closeAdminRemoteSessionResponse403 = {
  data: Problem
  status: 403
}

export type closeAdminRemoteSessionResponse409 = {
  data: Problem
  status: 409
}

export type closeAdminRemoteSessionResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200 | 403 | 409>
}

export type closeAdminRemoteSessionResponseSuccess = (closeAdminRemoteSessionResponse200) & {
  headers: Headers;
};
export type closeAdminRemoteSessionResponseError = (closeAdminRemoteSessionResponse403 | closeAdminRemoteSessionResponse409 | closeAdminRemoteSessionResponseDefault) & {
  headers: Headers;
};

export type closeAdminRemoteSessionResponse = (closeAdminRemoteSessionResponseSuccess | closeAdminRemoteSessionResponseError)

export const getCloseAdminRemoteSessionUrl = (sessionId: string,) => {




  return `/api/v1/admin/remote-access/sessions/${sessionId}/close`
}

/**
 * @summary Close or quarantine an eligible Remote Access session
 */
export const closeAdminRemoteSession = async (sessionId: string,
    remoteSessionCloseRequest: RemoteSessionCloseRequest, options?: RequestInit): Promise<closeAdminRemoteSessionResponse> => {

  return orvalClient<closeAdminRemoteSessionResponse>(getCloseAdminRemoteSessionUrl(sessionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remoteSessionCloseRequest)
  }
);}




export const getCloseAdminRemoteSessionMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeAdminRemoteSession>>, TError,{sessionId: string;data: RemoteSessionCloseRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof closeAdminRemoteSession>>, TError,{sessionId: string;data: RemoteSessionCloseRequest}, TContext> => {

const mutationKey = ['closeAdminRemoteSession'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closeAdminRemoteSession>>, {sessionId: string;data: RemoteSessionCloseRequest}> = (props) => {
          const {sessionId,data} = props ?? {};

          return  closeAdminRemoteSession(sessionId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CloseAdminRemoteSessionMutationResult = NonNullable<Awaited<ReturnType<typeof closeAdminRemoteSession>>>
    export type CloseAdminRemoteSessionMutationBody = RemoteSessionCloseRequest
    export type CloseAdminRemoteSessionMutationError = Problem

    /**
 * @summary Close or quarantine an eligible Remote Access session
 */
export const useCloseAdminRemoteSession = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeAdminRemoteSession>>, TError,{sessionId: string;data: RemoteSessionCloseRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof closeAdminRemoteSession>>,
        TError,
        {sessionId: string;data: RemoteSessionCloseRequest},
        TContext
      > => {
      return useMutation(getCloseAdminRemoteSessionMutationOptions(options), queryClient);
    }
    export type closeOwnedAdminRemoteSessionResponse200 = {
  data: RemoteSessionRead
  status: 200
}

export type closeOwnedAdminRemoteSessionResponse403 = {
  data: Problem
  status: 403
}

export type closeOwnedAdminRemoteSessionResponse409 = {
  data: Problem
  status: 409
}

export type closeOwnedAdminRemoteSessionResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200 | 403 | 409>
}

export type closeOwnedAdminRemoteSessionResponseSuccess = (closeOwnedAdminRemoteSessionResponse200) & {
  headers: Headers;
};
export type closeOwnedAdminRemoteSessionResponseError = (closeOwnedAdminRemoteSessionResponse403 | closeOwnedAdminRemoteSessionResponse409 | closeOwnedAdminRemoteSessionResponseDefault) & {
  headers: Headers;
};

export type closeOwnedAdminRemoteSessionResponse = (closeOwnedAdminRemoteSessionResponseSuccess | closeOwnedAdminRemoteSessionResponseError)

export const getCloseOwnedAdminRemoteSessionUrl = (sessionId: string,) => {




  return `/api/v1/admin/remote-access/sessions/${sessionId}/close-owned`
}

/**
 * Termination only for the same user and Admin membership with current auth-session, connect/manage capabilities and host assignment. Historical login, lease and ticket bindings are never transferred.
 * @summary Terminate an owned Remote Access session from a fresh authorized login
 */
export const closeOwnedAdminRemoteSession = async (sessionId: string,
    remoteSessionCloseRequest: RemoteSessionCloseRequest, options?: RequestInit): Promise<closeOwnedAdminRemoteSessionResponse> => {

  return orvalClient<closeOwnedAdminRemoteSessionResponse>(getCloseOwnedAdminRemoteSessionUrl(sessionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remoteSessionCloseRequest)
  }
);}




export const getCloseOwnedAdminRemoteSessionMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeOwnedAdminRemoteSession>>, TError,{sessionId: string;data: RemoteSessionCloseRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof closeOwnedAdminRemoteSession>>, TError,{sessionId: string;data: RemoteSessionCloseRequest}, TContext> => {

const mutationKey = ['closeOwnedAdminRemoteSession'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closeOwnedAdminRemoteSession>>, {sessionId: string;data: RemoteSessionCloseRequest}> = (props) => {
          const {sessionId,data} = props ?? {};

          return  closeOwnedAdminRemoteSession(sessionId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CloseOwnedAdminRemoteSessionMutationResult = NonNullable<Awaited<ReturnType<typeof closeOwnedAdminRemoteSession>>>
    export type CloseOwnedAdminRemoteSessionMutationBody = RemoteSessionCloseRequest
    export type CloseOwnedAdminRemoteSessionMutationError = Problem

    /**
 * @summary Terminate an owned Remote Access session from a fresh authorized login
 */
export const useCloseOwnedAdminRemoteSession = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeOwnedAdminRemoteSession>>, TError,{sessionId: string;data: RemoteSessionCloseRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof closeOwnedAdminRemoteSession>>,
        TError,
        {sessionId: string;data: RemoteSessionCloseRequest},
        TContext
      > => {
      return useMutation(getCloseOwnedAdminRemoteSessionMutationOptions(options), queryClient);
    }
    export type reconcileAdminRemoteAccessResponse200 = {
  data: RemoteReconcileResponse
  status: 200
}

export type reconcileAdminRemoteAccessResponse403 = {
  data: Problem
  status: 403
}

export type reconcileAdminRemoteAccessResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200 | 403>
}

export type reconcileAdminRemoteAccessResponseSuccess = (reconcileAdminRemoteAccessResponse200) & {
  headers: Headers;
};
export type reconcileAdminRemoteAccessResponseError = (reconcileAdminRemoteAccessResponse403 | reconcileAdminRemoteAccessResponseDefault) & {
  headers: Headers;
};

export type reconcileAdminRemoteAccessResponse = (reconcileAdminRemoteAccessResponseSuccess | reconcileAdminRemoteAccessResponseError)

export const getReconcileAdminRemoteAccessUrl = () => {




  return `/api/v1/admin/remote-access/reconcile`
}

/**
 * @summary Request privileged Remote Access inventory and mirror reconciliation
 */
export const reconcileAdminRemoteAccess = async (remoteReconcileRequest: RemoteReconcileRequest, options?: RequestInit): Promise<reconcileAdminRemoteAccessResponse> => {

  return orvalClient<reconcileAdminRemoteAccessResponse>(getReconcileAdminRemoteAccessUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remoteReconcileRequest)
  }
);}




export const getReconcileAdminRemoteAccessMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reconcileAdminRemoteAccess>>, TError,{data: RemoteReconcileRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reconcileAdminRemoteAccess>>, TError,{data: RemoteReconcileRequest}, TContext> => {

const mutationKey = ['reconcileAdminRemoteAccess'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reconcileAdminRemoteAccess>>, {data: RemoteReconcileRequest}> = (props) => {
          const {data} = props ?? {};

          return  reconcileAdminRemoteAccess(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReconcileAdminRemoteAccessMutationResult = NonNullable<Awaited<ReturnType<typeof reconcileAdminRemoteAccess>>>
    export type ReconcileAdminRemoteAccessMutationBody = RemoteReconcileRequest
    export type ReconcileAdminRemoteAccessMutationError = Problem

    /**
 * @summary Request privileged Remote Access inventory and mirror reconciliation
 */
export const useReconcileAdminRemoteAccess = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reconcileAdminRemoteAccess>>, TError,{data: RemoteReconcileRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reconcileAdminRemoteAccess>>,
        TError,
        {data: RemoteReconcileRequest},
        TContext
      > => {
      return useMutation(getReconcileAdminRemoteAccessMutationOptions(options), queryClient);
    }
    export type getAdminRemoteSelectedAssignmentsResponse200 = {
  data: RemoteSelectedAssignmentsRead
  status: 200
}

export type getAdminRemoteSelectedAssignmentsResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200>
}

export type getAdminRemoteSelectedAssignmentsResponseSuccess = (getAdminRemoteSelectedAssignmentsResponse200) & {
  headers: Headers;
};
export type getAdminRemoteSelectedAssignmentsResponseError = (getAdminRemoteSelectedAssignmentsResponseDefault) & {
  headers: Headers;
};

export type getAdminRemoteSelectedAssignmentsResponse = (getAdminRemoteSelectedAssignmentsResponseSuccess | getAdminRemoteSelectedAssignmentsResponseError)

export const getGetAdminRemoteSelectedAssignmentsUrl = (membershipId: string,) => {




  return `/api/v1/admin/remote-access/assignments/${membershipId}`
}

/**
 * @summary Read an eligible team member's selected server assignments
 */
export const getAdminRemoteSelectedAssignments = async (membershipId: string, options?: RequestInit): Promise<getAdminRemoteSelectedAssignmentsResponse> => {

  return orvalClient<getAdminRemoteSelectedAssignmentsResponse>(getGetAdminRemoteSelectedAssignmentsUrl(membershipId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminRemoteSelectedAssignmentsQueryKey = (membershipId: string,) => {
    return [
    `/api/v1/admin/remote-access/assignments/${membershipId}`
    ] as const;
    }


export const getGetAdminRemoteSelectedAssignmentsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>, TError = Problem>(membershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminRemoteSelectedAssignmentsQueryKey(membershipId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>> = ({ signal }) => getAdminRemoteSelectedAssignments(membershipId, { signal });





   return  { queryKey, queryFn, enabled: membershipId !== null && membershipId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminRemoteSelectedAssignmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>>
export type GetAdminRemoteSelectedAssignmentsQueryError = Problem


export function useGetAdminRemoteSelectedAssignments<TData = Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>, TError = Problem>(
 membershipId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>,
          TError,
          Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminRemoteSelectedAssignments<TData = Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>, TError = Problem>(
 membershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>,
          TError,
          Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminRemoteSelectedAssignments<TData = Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>, TError = Problem>(
 membershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read an eligible team member's selected server assignments
 */

export function useGetAdminRemoteSelectedAssignments<TData = Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>, TError = Problem>(
 membershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminRemoteSelectedAssignmentsQueryOptions(membershipId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type replaceAdminRemoteSelectedAssignmentsResponse200 = {
  data: RemoteSelectedAssignmentsRead
  status: 200
}

export type replaceAdminRemoteSelectedAssignmentsResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200>
}

export type replaceAdminRemoteSelectedAssignmentsResponseSuccess = (replaceAdminRemoteSelectedAssignmentsResponse200) & {
  headers: Headers;
};
export type replaceAdminRemoteSelectedAssignmentsResponseError = (replaceAdminRemoteSelectedAssignmentsResponseDefault) & {
  headers: Headers;
};

export type replaceAdminRemoteSelectedAssignmentsResponse = (replaceAdminRemoteSelectedAssignmentsResponseSuccess | replaceAdminRemoteSelectedAssignmentsResponseError)

export const getReplaceAdminRemoteSelectedAssignmentsUrl = (membershipId: string,) => {




  return `/api/v1/admin/remote-access/assignments/${membershipId}`
}

/**
 * @summary Replace selected server access without changing policy-managed assignments
 */
export const replaceAdminRemoteSelectedAssignments = async (membershipId: string,
    remoteSelectedAssignmentsWrite: RemoteSelectedAssignmentsWrite, options?: RequestInit): Promise<replaceAdminRemoteSelectedAssignmentsResponse> => {

  return orvalClient<replaceAdminRemoteSelectedAssignmentsResponse>(getReplaceAdminRemoteSelectedAssignmentsUrl(membershipId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remoteSelectedAssignmentsWrite)
  }
);}




export const getReplaceAdminRemoteSelectedAssignmentsMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceAdminRemoteSelectedAssignments>>, TError,{membershipId: string;data: RemoteSelectedAssignmentsWrite}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof replaceAdminRemoteSelectedAssignments>>, TError,{membershipId: string;data: RemoteSelectedAssignmentsWrite}, TContext> => {

const mutationKey = ['replaceAdminRemoteSelectedAssignments'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replaceAdminRemoteSelectedAssignments>>, {membershipId: string;data: RemoteSelectedAssignmentsWrite}> = (props) => {
          const {membershipId,data} = props ?? {};

          return  replaceAdminRemoteSelectedAssignments(membershipId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplaceAdminRemoteSelectedAssignmentsMutationResult = NonNullable<Awaited<ReturnType<typeof replaceAdminRemoteSelectedAssignments>>>
    export type ReplaceAdminRemoteSelectedAssignmentsMutationBody = RemoteSelectedAssignmentsWrite
    export type ReplaceAdminRemoteSelectedAssignmentsMutationError = Problem

    /**
 * @summary Replace selected server access without changing policy-managed assignments
 */
export const useReplaceAdminRemoteSelectedAssignments = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceAdminRemoteSelectedAssignments>>, TError,{membershipId: string;data: RemoteSelectedAssignmentsWrite}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof replaceAdminRemoteSelectedAssignments>>,
        TError,
        {membershipId: string;data: RemoteSelectedAssignmentsWrite},
        TContext
      > => {
      return useMutation(getReplaceAdminRemoteSelectedAssignmentsMutationOptions(options), queryClient);
    }
    export type createAdminRemoteAssignmentPolicyResponse201 = {
  data: RemoteAssignmentPolicyRead
  status: 201
}

export type createAdminRemoteAssignmentPolicyResponse403 = {
  data: Problem
  status: 403
}

export type createAdminRemoteAssignmentPolicyResponse409 = {
  data: Problem
  status: 409
}

export type createAdminRemoteAssignmentPolicyResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 201 | 403 | 409>
}

export type createAdminRemoteAssignmentPolicyResponseSuccess = (createAdminRemoteAssignmentPolicyResponse201) & {
  headers: Headers;
};
export type createAdminRemoteAssignmentPolicyResponseError = (createAdminRemoteAssignmentPolicyResponse403 | createAdminRemoteAssignmentPolicyResponse409 | createAdminRemoteAssignmentPolicyResponseDefault) & {
  headers: Headers;
};

export type createAdminRemoteAssignmentPolicyResponse = (createAdminRemoteAssignmentPolicyResponseSuccess | createAdminRemoteAssignmentPolicyResponseError)

export const getCreateAdminRemoteAssignmentPolicyUrl = () => {




  return `/api/v1/admin/remote-access/assignment-policies`
}

/**
 * @summary Create one explicit all-host assignment policy for a membership
 */
export const createAdminRemoteAssignmentPolicy = async (remoteAssignmentPolicyWrite: RemoteAssignmentPolicyWrite, options?: RequestInit): Promise<createAdminRemoteAssignmentPolicyResponse> => {

  return orvalClient<createAdminRemoteAssignmentPolicyResponse>(getCreateAdminRemoteAssignmentPolicyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remoteAssignmentPolicyWrite)
  }
);}




export const getCreateAdminRemoteAssignmentPolicyMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminRemoteAssignmentPolicy>>, TError,{data: RemoteAssignmentPolicyWrite}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAdminRemoteAssignmentPolicy>>, TError,{data: RemoteAssignmentPolicyWrite}, TContext> => {

const mutationKey = ['createAdminRemoteAssignmentPolicy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAdminRemoteAssignmentPolicy>>, {data: RemoteAssignmentPolicyWrite}> = (props) => {
          const {data} = props ?? {};

          return  createAdminRemoteAssignmentPolicy(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAdminRemoteAssignmentPolicyMutationResult = NonNullable<Awaited<ReturnType<typeof createAdminRemoteAssignmentPolicy>>>
    export type CreateAdminRemoteAssignmentPolicyMutationBody = RemoteAssignmentPolicyWrite
    export type CreateAdminRemoteAssignmentPolicyMutationError = Problem

    /**
 * @summary Create one explicit all-host assignment policy for a membership
 */
export const useCreateAdminRemoteAssignmentPolicy = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminRemoteAssignmentPolicy>>, TError,{data: RemoteAssignmentPolicyWrite}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAdminRemoteAssignmentPolicy>>,
        TError,
        {data: RemoteAssignmentPolicyWrite},
        TContext
      > => {
      return useMutation(getCreateAdminRemoteAssignmentPolicyMutationOptions(options), queryClient);
    }
    export type amendAdminRemoteAssignmentPolicyResponse200 = {
  data: RemoteAssignmentPolicyRead
  status: 200
}

export type amendAdminRemoteAssignmentPolicyResponse403 = {
  data: Problem
  status: 403
}

export type amendAdminRemoteAssignmentPolicyResponse404 = {
  data: Problem
  status: 404
}

export type amendAdminRemoteAssignmentPolicyResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200 | 403 | 404>
}

export type amendAdminRemoteAssignmentPolicyResponseSuccess = (amendAdminRemoteAssignmentPolicyResponse200) & {
  headers: Headers;
};
export type amendAdminRemoteAssignmentPolicyResponseError = (amendAdminRemoteAssignmentPolicyResponse403 | amendAdminRemoteAssignmentPolicyResponse404 | amendAdminRemoteAssignmentPolicyResponseDefault) & {
  headers: Headers;
};

export type amendAdminRemoteAssignmentPolicyResponse = (amendAdminRemoteAssignmentPolicyResponseSuccess | amendAdminRemoteAssignmentPolicyResponseError)

export const getAmendAdminRemoteAssignmentPolicyUrl = (policyId: string,) => {




  return `/api/v1/admin/remote-access/assignment-policies/${policyId}`
}

/**
 * @summary Amend and rematerialize an explicit all-host assignment policy
 */
export const amendAdminRemoteAssignmentPolicy = async (policyId: string,
    remoteAssignmentPolicyWrite: RemoteAssignmentPolicyWrite, options?: RequestInit): Promise<amendAdminRemoteAssignmentPolicyResponse> => {

  return orvalClient<amendAdminRemoteAssignmentPolicyResponse>(getAmendAdminRemoteAssignmentPolicyUrl(policyId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remoteAssignmentPolicyWrite)
  }
);}




export const getAmendAdminRemoteAssignmentPolicyMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof amendAdminRemoteAssignmentPolicy>>, TError,{policyId: string;data: RemoteAssignmentPolicyWrite}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof amendAdminRemoteAssignmentPolicy>>, TError,{policyId: string;data: RemoteAssignmentPolicyWrite}, TContext> => {

const mutationKey = ['amendAdminRemoteAssignmentPolicy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof amendAdminRemoteAssignmentPolicy>>, {policyId: string;data: RemoteAssignmentPolicyWrite}> = (props) => {
          const {policyId,data} = props ?? {};

          return  amendAdminRemoteAssignmentPolicy(policyId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AmendAdminRemoteAssignmentPolicyMutationResult = NonNullable<Awaited<ReturnType<typeof amendAdminRemoteAssignmentPolicy>>>
    export type AmendAdminRemoteAssignmentPolicyMutationBody = RemoteAssignmentPolicyWrite
    export type AmendAdminRemoteAssignmentPolicyMutationError = Problem

    /**
 * @summary Amend and rematerialize an explicit all-host assignment policy
 */
export const useAmendAdminRemoteAssignmentPolicy = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof amendAdminRemoteAssignmentPolicy>>, TError,{policyId: string;data: RemoteAssignmentPolicyWrite}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof amendAdminRemoteAssignmentPolicy>>,
        TError,
        {policyId: string;data: RemoteAssignmentPolicyWrite},
        TContext
      > => {
      return useMutation(getAmendAdminRemoteAssignmentPolicyMutationOptions(options), queryClient);
    }
    export type revokeAdminRemoteAssignmentPolicyResponse200 = {
  data: RemoteAssignmentPolicyRead
  status: 200
}

export type revokeAdminRemoteAssignmentPolicyResponse403 = {
  data: Problem
  status: 403
}

export type revokeAdminRemoteAssignmentPolicyResponse404 = {
  data: Problem
  status: 404
}

export type revokeAdminRemoteAssignmentPolicyResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200 | 403 | 404>
}

export type revokeAdminRemoteAssignmentPolicyResponseSuccess = (revokeAdminRemoteAssignmentPolicyResponse200) & {
  headers: Headers;
};
export type revokeAdminRemoteAssignmentPolicyResponseError = (revokeAdminRemoteAssignmentPolicyResponse403 | revokeAdminRemoteAssignmentPolicyResponse404 | revokeAdminRemoteAssignmentPolicyResponseDefault) & {
  headers: Headers;
};

export type revokeAdminRemoteAssignmentPolicyResponse = (revokeAdminRemoteAssignmentPolicyResponseSuccess | revokeAdminRemoteAssignmentPolicyResponseError)

export const getRevokeAdminRemoteAssignmentPolicyUrl = (policyId: string,) => {




  return `/api/v1/admin/remote-access/assignment-policies/${policyId}`
}

/**
 * @summary Revoke an explicit all-host assignment policy
 */
export const revokeAdminRemoteAssignmentPolicy = async (policyId: string, options?: RequestInit): Promise<revokeAdminRemoteAssignmentPolicyResponse> => {

  return orvalClient<revokeAdminRemoteAssignmentPolicyResponse>(getRevokeAdminRemoteAssignmentPolicyUrl(policyId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getRevokeAdminRemoteAssignmentPolicyMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeAdminRemoteAssignmentPolicy>>, TError,{policyId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof revokeAdminRemoteAssignmentPolicy>>, TError,{policyId: string}, TContext> => {

const mutationKey = ['revokeAdminRemoteAssignmentPolicy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeAdminRemoteAssignmentPolicy>>, {policyId: string}> = (props) => {
          const {policyId} = props ?? {};

          return  revokeAdminRemoteAssignmentPolicy(policyId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeAdminRemoteAssignmentPolicyMutationResult = NonNullable<Awaited<ReturnType<typeof revokeAdminRemoteAssignmentPolicy>>>

    export type RevokeAdminRemoteAssignmentPolicyMutationError = Problem

    /**
 * @summary Revoke an explicit all-host assignment policy
 */
export const useRevokeAdminRemoteAssignmentPolicy = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeAdminRemoteAssignmentPolicy>>, TError,{policyId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revokeAdminRemoteAssignmentPolicy>>,
        TError,
        {policyId: string},
        TContext
      > => {
      return useMutation(getRevokeAdminRemoteAssignmentPolicyMutationOptions(options), queryClient);
    }
    export type consumeRemoteLaunchTicketResponse200 = {
  data: RemoteLaunchTicketConsumeResponse
  status: 200
}

export type consumeRemoteLaunchTicketResponse401 = {
  data: Problem
  status: 401
}

export type consumeRemoteLaunchTicketResponse409 = {
  data: Problem
  status: 409
}

export type consumeRemoteLaunchTicketResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200 | 401 | 409>
}

export type consumeRemoteLaunchTicketResponseSuccess = (consumeRemoteLaunchTicketResponse200) & {
  headers: Headers;
};
export type consumeRemoteLaunchTicketResponseError = (consumeRemoteLaunchTicketResponse401 | consumeRemoteLaunchTicketResponse409 | consumeRemoteLaunchTicketResponseDefault) & {
  headers: Headers;
};

export type consumeRemoteLaunchTicketResponse = (consumeRemoteLaunchTicketResponseSuccess | consumeRemoteLaunchTicketResponseError)

export const getConsumeRemoteLaunchTicketUrl = () => {




  return `/api/v1/internal/remote-access/tickets/consume`
}

/**
 * Private bridge-only exchange. PEXIFY revalidates the ticket's server-derived user, membership, auth session, host, and lease binding before releasing opaque adapter descriptors.
 * @summary Atomically consume one Remote Access ticket for the authenticated bridge
 */
export const consumeRemoteLaunchTicket = async (remoteLaunchTicketConsumeRequest: RemoteLaunchTicketConsumeRequest, options?: RequestInit): Promise<consumeRemoteLaunchTicketResponse> => {

  return orvalClient<consumeRemoteLaunchTicketResponse>(getConsumeRemoteLaunchTicketUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remoteLaunchTicketConsumeRequest)
  }
);}




export const getConsumeRemoteLaunchTicketMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consumeRemoteLaunchTicket>>, TError,{data: RemoteLaunchTicketConsumeRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof consumeRemoteLaunchTicket>>, TError,{data: RemoteLaunchTicketConsumeRequest}, TContext> => {

const mutationKey = ['consumeRemoteLaunchTicket'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof consumeRemoteLaunchTicket>>, {data: RemoteLaunchTicketConsumeRequest}> = (props) => {
          const {data} = props ?? {};

          return  consumeRemoteLaunchTicket(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConsumeRemoteLaunchTicketMutationResult = NonNullable<Awaited<ReturnType<typeof consumeRemoteLaunchTicket>>>
    export type ConsumeRemoteLaunchTicketMutationBody = RemoteLaunchTicketConsumeRequest
    export type ConsumeRemoteLaunchTicketMutationError = Problem

    /**
 * @summary Atomically consume one Remote Access ticket for the authenticated bridge
 */
export const useConsumeRemoteLaunchTicket = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consumeRemoteLaunchTicket>>, TError,{data: RemoteLaunchTicketConsumeRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof consumeRemoteLaunchTicket>>,
        TError,
        {data: RemoteLaunchTicketConsumeRequest},
        TContext
      > => {
      return useMutation(getConsumeRemoteLaunchTicketMutationOptions(options), queryClient);
    }
    export type reportRemoteGatewayResultResponse200 = {
  data: RemoteGatewayResultAck
  status: 200
}

export type reportRemoteGatewayResultResponse401 = {
  data: Problem
  status: 401
}

export type reportRemoteGatewayResultResponse409 = {
  data: Problem
  status: 409
}

export type reportRemoteGatewayResultResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200 | 401 | 409>
}

export type reportRemoteGatewayResultResponseSuccess = (reportRemoteGatewayResultResponse200) & {
  headers: Headers;
};
export type reportRemoteGatewayResultResponseError = (reportRemoteGatewayResultResponse401 | reportRemoteGatewayResultResponse409 | reportRemoteGatewayResultResponseDefault) & {
  headers: Headers;
};

export type reportRemoteGatewayResultResponse = (reportRemoteGatewayResultResponseSuccess | reportRemoteGatewayResultResponseError)

export const getReportRemoteGatewayResultUrl = (sessionId: string,) => {




  return `/api/v1/internal/remote-access/sessions/${sessionId}/gateway-result`
}

/**
 * @summary Record one normalized gateway result from the authenticated bridge
 */
export const reportRemoteGatewayResult = async (sessionId: string,
    remoteGatewayResultReport: RemoteGatewayResultReport, options?: RequestInit): Promise<reportRemoteGatewayResultResponse> => {

  return orvalClient<reportRemoteGatewayResultResponse>(getReportRemoteGatewayResultUrl(sessionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remoteGatewayResultReport)
  }
);}




export const getReportRemoteGatewayResultMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportRemoteGatewayResult>>, TError,{sessionId: string;data: RemoteGatewayResultReport}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reportRemoteGatewayResult>>, TError,{sessionId: string;data: RemoteGatewayResultReport}, TContext> => {

const mutationKey = ['reportRemoteGatewayResult'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reportRemoteGatewayResult>>, {sessionId: string;data: RemoteGatewayResultReport}> = (props) => {
          const {sessionId,data} = props ?? {};

          return  reportRemoteGatewayResult(sessionId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReportRemoteGatewayResultMutationResult = NonNullable<Awaited<ReturnType<typeof reportRemoteGatewayResult>>>
    export type ReportRemoteGatewayResultMutationBody = RemoteGatewayResultReport
    export type ReportRemoteGatewayResultMutationError = Problem

    /**
 * @summary Record one normalized gateway result from the authenticated bridge
 */
export const useReportRemoteGatewayResult = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportRemoteGatewayResult>>, TError,{sessionId: string;data: RemoteGatewayResultReport}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reportRemoteGatewayResult>>,
        TError,
        {sessionId: string;data: RemoteGatewayResultReport},
        TContext
      > => {
      return useMutation(getReportRemoteGatewayResultMutationOptions(options), queryClient);
    }
